export default {
  path: 'drug-price',
  component: () => import('@/views/settingSystem/pages/drug-price/DrugPrice.vue'),
  children: [
    {
      path: '',
      name: 'DrugPriceCreate',
      component: () => import('@/views/settingSystem/pages/drug-price/DrugPriceCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }

  ]
}
